var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGithub = function SvgGithub(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#github_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.333,
    d: "M6 12.667c-2.867.933-2.867-1.667-4-2M10 14v-2.333c0-.667.067-.934-.333-1.334 1.866-.2 3.666-.933 3.666-4 0-.796-.311-1.561-.866-2.133a2.8 2.8 0 0 0-.067-2.133s-.733-.2-2.333.866a8.2 8.2 0 0 0-4.134 0C4.333 1.867 3.6 2.067 3.6 2.067A2.8 2.8 0 0 0 3.533 4.2a3.07 3.07 0 0 0-.866 2.133c0 3.067 1.8 3.8 3.666 4-.4.4-.4.8-.333 1.334V14"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "github_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgGithub;